import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[luiFlipCardFront]',
    standalone: false
})
export class FlipCardFrontDirective {
  @HostBinding('class') hostClass = 'flip-card-front';
}
